module.exports = __webpack_public_path__ + "static/media/wallyDescription.d630f7cd.svg";